<template>
    <div>
        <el-form :inline="true" :model="vedioVipForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="充值状态：">
                <el-select v-model="vedioVipForm.buyState" clearable>
                    <el-option value="1" label="订单未付款"></el-option>
                    <el-option value="2" label="付款待充值"></el-option>
                    <el-option value="3" label="充值失败待退款"></el-option>
                    <el-option value="4" label="充值成功"></el-option>
                    <el-option value="5" label="退款成功"></el-option>
                    <el-option value="6" label="退款失败"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="会员账号："> 
                <el-input  v-model="vedioVipForm.account"  @keyup.enter.native="getVedioOrderListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品编号：">
                <el-input  v-model="vedioVipForm.shopId" @keyup.enter.native="getVedioOrderListHandler"  clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getVedioOrderListHandler">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" border  >
            <el-table-column prop="serialno" label="流水号"></el-table-column>
            <el-table-column prop="account" label="会员账号"></el-table-column>
            <el-table-column prop="price" label="充值金额"></el-table-column>
            <el-table-column prop="createTime" label="充值时间"></el-table-column>
            <el-table-column prop="shopNickname" label="商品名"></el-table-column>
            <el-table-column prop="buyStateName" label="充值状态"></el-table-column>
            <el-table-column prop="shopId" label="商品编号"></el-table-column>
        </el-table>
                  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
import {getVedioOrderList} from '@/api/vedio.js'
export default {
    name: 'vedioMgt',
    data(){
        return {
            vedioVipForm: {
                buyState: '',
                account: '',
                shopId: ''
            },
            tableData: [],
            currentPage: 1,
            pageSize: 15,
            total: 0
        }
    },
    methods: {
        getVedioOrderListHandler(){
            var data = {
                perPageNum: this.pageSize,
                pageNo: this.currentPage              
            }
            for(var key in this.vedioVipForm){
                data[key] = this.vedioVipForm[key];                              
            }              
            getVedioOrderList(data).then(res => {
                if(res.data.result == true){
                    var result = res.data;
                    this.tableData = result.datum.list
                    this.total = result.datum.total;
                    this.currentPage = result.datum.pageNum;
                    this.pageSize = result.datum.pageSize;                    
                }
            })
        },
        handleSizeChange(val){
            this.pageSize = val;
            this.getVedioOrderListHandler();
        },
        handleCurrentChange(val){
            this.currentPage = val;
            this.getVedioOrderListHandler();
        }        
    },
    created(){
        this.getVedioOrderListHandler();
    }
}
</script>
